import AuthService from "./AuthService";
import UrlEncodingService from "./UrlEncodingService";
import EnvironmentService from "./EnvironmentService";

import _ from "lodash";
import {funcList } from "@/services/FunctionalityListService";

export default {
    saveProfileDetails(profile) {
        this.saveCurrentTenant(profile.currentTenant.code);
        this.saveUserId(profile.userId);
        this.saveUserPermissions(JSON.stringify(profile.permissionsV2));
        this.saveLocale(profile.locale);
        if(profile.visibility.find(x=> x.code === 'raw')) {
            this.saveShowRawTab(true);
        }
        else {
            this.saveShowRawTab(false);

        }
    },

    saveCurrentTenant(currentTenant) {
        localStorage.setItem('currentTenant', currentTenant);
    },
    saveUserId(userId) {
        localStorage.setItem('userId', userId);
    },
    saveShowRawTab(visibility){
        localStorage.setItem('showRawTab', visibility);

    },
    saveUserPermissions(permissionsV2) {
        localStorage.setItem('permissions', JSON.stringify(this.convertPermissions(JSON.parse(permissionsV2))));
        localStorage.setItem('permissionsV2', permissionsV2)
    },
    saveLocale(locale) {
        localStorage.setItem('locale', locale);
    },
    convertPermissions(permissions){

        const permissionsV2 = {};
        permissions.forEach(p => {
            permissionsV2[p.entityPermission.entity] = p.entityPermission.serviceAccess;
        });

        return permissionsV2;
    },
    filterPermissions(permissions, functionalityList, showRawTab) {

        const parentsFiltered = this.filterFuncionalityListByPermissions(permissions, functionalityList, showRawTab);

        parentsFiltered.forEach((parent, i) => {
            if (parent.items) {
                parentsFiltered[i]['items'] = [...this.filterFuncionalityListByPermissions(permissions, parent.items)];
            }
        });

        return parentsFiltered.filter((val) => {
            return !val.items || val.items.length > 0;
        });
    },
    filterFuncionalityListByPermissions(permissions, functionalityList, showRawTab) {

            return functionalityList.filter(function (e) {
                var result = false;
                if (e.id) {
                    if (e.id in permissions) {
                        result = permissions[e.id] === "read" || permissions[e.id] === "write";
                    }
                    else {
                        if(e.onlyWithRawTabPermission && showRawTab) {
                            result = true;
                        }
                    }
                } else {
                    result = true;
                }
                return result;
            });


    },
    clearAuthData() {
        localStorage.removeItem('token');
        localStorage.removeItem('permissions');
        localStorage.removeItem('tenants');
        localStorage.removeItem('currentTenant');
        localStorage.removeItem('local');
        localStorage.removeItem('userId');
        localStorage.removeItem('assumeUser');
    },
    getAuthData() {
        const token = localStorage.getItem('token');
        if (!token) {
            return;
        }
        return {
            token: token,
        };
    },
    assumeUser(value) {
        localStorage.setItem('assumeUser', value);
    },
    getAssumedUser() {
        return localStorage.getItem('assumeUser');
    },
    parseJwt(token) {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace('-', '+').replace('_', '/');
        return JSON.parse(window.atob(base64));
    },
    hasRequiredPermission(type, permission) {
        let permissions = JSON.parse(localStorage.getItem("permissions"));
        return permissions && permissions[type] === permission;
    },
    logout(logoutUrl) {
        let token = localStorage.getItem("token");
        AuthService.clearAuthData();
        fetch(UrlEncodingService.buildEncodedUrl({
            baseEndpointUrl: `${EnvironmentService.getUrl()}/api/${EnvironmentService.getVersion()}/admin/profile/clearAssumeUser`,
        }), {
            method: 'POST',
            headers: new Headers({
                'Authorization': `Bearer ${token}`,
            })
        })
            .finally(() => {
                window.location.replace(`${logoutUrl}`);
            })
    }
}
